import { useEffect, useState } from 'react';
import type { ComponentType } from 'react';
import { View } from 'react-native';
import type { BreedersMapProps } from './index';

type BreedersMapComponent = ComponentType<BreedersMapProps>;

function scheduleIdle(callback: () => void) {
  if (typeof window.requestIdleCallback === 'function') {
    const idleId = window.requestIdleCallback(callback, { timeout: 750 });

    return () => window.cancelIdleCallback(idleId);
  }

  const timeoutId = window.setTimeout(callback, 0);

  return () => window.clearTimeout(timeoutId);
}

export function BreedersMap(props: BreedersMapProps) {
  const [MapComponent, setMapComponent] = useState<BreedersMapComponent | null>(null);

  useEffect(() => {
    let mounted = true;

    const cancelIdle = scheduleIdle(() => {
      import('./breeders-map.web').then((module) => {
        if (mounted) {
          setMapComponent(() => module.BreedersMap);
        }
      });
    });

    return () => {
      mounted = false;
      cancelIdle();
    };
  }, []);

  if (!MapComponent) {
    return <View className={'size-full'} />;
  }

  return <MapComponent {...props} />;
}
